import {gql} from "@apollo/client";

const getPlayerQuery = gql`
    query getPlayer ($playerId: String!) {
        player: player(id: $playerId){
            id
            avatar
            name
            position
            dob
            marketValue
            onLoan
            height
            weight
            foot
            overallScore
            wage
            team {
                name
            }

            careerStats{
                goalsScored
                shootAccuracy
                passingAccuracy
                tackleSuccessRate
            }

            positions{
                position
                map{
                    location
                    color
                }
            }

            transfers{
                teamLeft{
                    name
                }
                teamJoined{
                    name
                }
                transferDate
                joiningDate
                role
                transferType
            }
        }
    }
`;


const getCompetitionsQuery = gql`
    query getCompetitions {
        competitions: competitions{
            id
            name
        }
    }
`;


const getCareerStatsFiltersQuery = gql`
    {
        competitions: competitions{
            id
            name
        }

        seasons: seasons{
            id
            name
        }

        locations: competitions{
            id
            name
        }
    }
`;


const playerBasicInformationCardQuery = gql`
    query getPlayer ($playerId: String!) {
        player: player(id: $playerId){
            #Age
            dob
            #goalsScored
            careerStats{
                goalsScored
            }
            #marketValue
            marketValue
            #foot
            foot
            #Nationality
            nationality{
                name
            }
            #Passport
            passport{
                name
            }
            #Current team
            team{
                name
            }
            #positions
            position
            #Int. Matches
            #Int. Goals
            #Total Matches
            #Total Goals
            careerStats{
                intMatchesPlayed
                intGoalsScored
                matchesPlayed
            }
        }
    }
`;

export const fullProfileQueries = {
    getPlayer: getPlayerQuery,
    getCompetitions: getCompetitionsQuery,
    getCareerStatsFilters: getCareerStatsFiltersQuery
};
